import { render } from "./notification.html?vue&type=template&id=04eae5e8&external"
import script from "./notification.js?vue&type=script&lang=js&external"
export * from "./notification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__